import React from 'react';
import _ from 'lodash';

import { Dropdown, Form, Button, TextArea, Grid, Table, Icon } from 'semantic-ui-react';
import CustomDropdown from '../../../common/CustomDropdown';

const ASSET_CUSTOM_ATTRBIUTE_TYPES_ALLOWED = ['string', 'integer'];
const ASSET_CUSTOM_ATTRBIUTE_OBJECT_TYPES_ALLOWED = ['stop'];

const AssetCriteriaComponent = ({
  assetCriteriaTemplate = {},
  onAssetCriteriaChange,
  onAssetCriteriaStopSearchChange,
  onAssetCriteriaLocationSearchChange,
  formik,
  onAssetCriteriaPreviewButtonClicked,
  allAssetAttributes = [],
}) => {
  const { info = {}, isLoading } = assetCriteriaTemplate;
  const {
    areaIds = [],
    areasOptions = [],
    typesOptions = [],
    types = [],
    stopSearchInfo = {},
    locationSearchInfo = {},
    stopIds = [],
    locationIds = [],
    previewInfo = {},
    customAttributes = {},
  } = info;

  const attributesAllowed = allAssetAttributes.filter(
    (item) =>
      ASSET_CUSTOM_ATTRBIUTE_TYPES_ALLOWED.indexOf(item.attributeType) !== -1 &&
      (!item.objectType || ASSET_CUSTOM_ATTRBIUTE_OBJECT_TYPES_ALLOWED.indexOf(item.objectType) !== -1)
  );
  const attributesAllowedMap = _.keyBy(attributesAllowed, 'attributeName');
  const unSelectedAttributesOptions = attributesAllowed
    .filter((item) => Object.keys(customAttributes).indexOf(item.attributeName) === -1)
    .map((item) => {
      return {
        key: item.attributeName,
        value: item.attributeName,
        text: item.attributeDisplayName,
        originalobject: item,
      };
    });
  const selectedAttributesRows = Object.keys(customAttributes)
    .filter((key) => attributesAllowedMap[key])
    .map((key) => {
      const item = attributesAllowedMap[key];
      return {
        options: [
          ...unSelectedAttributesOptions,
          {
            key: item.attributeName,
            value: item.attributeName,
            text: item.attributeDisplayName,
            originalobject: item,
          },
        ],
        optionValue: customAttributes[key],
        optionsKey: key,
        optionInputType: item.attributeType === 'string' ? 'text' : 'number',
      };
    });
  const lastRow = unSelectedAttributesOptions.length
    ? [
        {
          options: [...unSelectedAttributesOptions],
          optionsKey: '',
          // optionInputType: '',
        },
      ]
    : [];
  const customAttributeRows = [...selectedAttributesRows, ...lastRow];

  let isCustomAttributesValid = true;
  for (const key of Object.keys(customAttributes)) {
    if (customAttributes[key] === '') {
      isCustomAttributesValid = false;
    }
  }

  const enablePreview = !!(areaIds.length || locationIds.length) && isCustomAttributesValid;

  return (
    <Grid style={{ margin: '0 -1rem' }}>
      <Grid.Row>
        <Grid.Column>
          <Form.Field>
            <label>CHOOSE ASSETS FROM CRITERIA (OR) LOCATIONS</label>
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <Form.Field>
            <label>Area (s)</label>
            <CustomDropdown
              placeholder="Choose Areas"
              search
              multiple
              selection
              options={areasOptions}
              value={areaIds}
              onChange={(event, data) => {
                onAssetCriteriaChange(data, formik);
              }}
              disabled={isLoading}
              name="areaIds"
            />
          </Form.Field>
          <Form.Field style={{ marginTop: '10px' }}>
            <label>Asset Type (s)</label>
            <CustomDropdown
              placeholder="Choose Asset Types"
              search
              multiple
              selection
              options={typesOptions}
              value={types}
              onChange={(event, data) => {
                onAssetCriteriaChange(data, formik);
              }}
              disabled={isLoading}
              name="types"
            />
          </Form.Field>
          <Form.Field style={{ marginTop: '10px' }}>
            <label>Stop(s)</label>
            <Dropdown
              placeholder="Search Stops"
              multiple
              fluid
              search
              selection
              options={stopSearchInfo.items || []}
              value={stopIds || []}
              name="stopIds"
              onChange={(event, data) => {
                onAssetCriteriaChange(data, formik);
              }}
              onSearchChange={(event) => {
                onAssetCriteriaStopSearchChange({ formik, event, dropdownFor: 'stop' });
              }}
              loading={stopSearchInfo.isLoading}
              disabled={isLoading}
            />
          </Form.Field>
          <Table id="partsTable">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={7} textAlign="left">
                  Global Attribute Name
                </Table.HeaderCell>
                <Table.HeaderCell width={7}>Value</Table.HeaderCell>
                <Table.HeaderCell width={2}>Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {customAttributeRows.map((row, index) => (
              <Table.Body key={index}>
                <Table.Row>
                  <Table.Cell>
                    <Form.Field style={{ height: '50px' }}>
                      <CustomDropdown
                        placeholder="Choose asset attribute"
                        search
                        selection
                        options={row.options}
                        value={row.optionsKey}
                        onChange={(event, data) => {
                          onAssetCriteriaChange(
                            {
                              name: 'customAttributes',
                              value: {
                                ...customAttributes,
                                ...{
                                  [data.value]: '',
                                },
                              },
                            },
                            formik
                          );
                        }}
                        disabled={row.optionsKey}
                      />
                    </Form.Field>
                  </Table.Cell>
                  {row.optionsKey && (
                    <>
                      <Table.Cell>
                        <Form.Field style={{ height: '50px' }}>
                          <input
                            type={row.optionInputType}
                            name={index}
                            // value={row.optionValue}
                            disabled={isLoading}
                            onBlur={(event) => {
                              let { value } = event.target;
                              if (row.optionInputType === 'number') {
                                value = parseInt(value, 10);
                              }
                              onAssetCriteriaChange(
                                {
                                  name: 'customAttributes',
                                  value: {
                                    ...customAttributes,
                                    ...{
                                      [row.optionsKey]: value,
                                    },
                                  },
                                },
                                formik
                              );
                            }}
                            // onClick={onClick}
                          />
                          {/* {formik.errors.parts_required &&
                        formik.errors.parts_required[index] &&
                        formik.errors.parts_required[index].picklistOptionId && (
                          <div className="errorText">*{formik.errors.parts_required[index].picklistOptionId}</div>
                        )} */}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          <div
                            onClick={() => {
                              const newValue = { ...customAttributes };
                              delete newValue[row.optionsKey];
                              onAssetCriteriaChange(
                                {
                                  name: 'customAttributes',
                                  value: newValue,
                                },
                                formik
                              );
                            }}
                          >
                            <Icon name="trash alternate outline" style={{ cursor: 'pointer' }} />
                          </div>
                        </Form.Field>
                      </Table.Cell>
                    </>
                  )}
                </Table.Row>
              </Table.Body>
            ))}
          </Table>
          {previewInfo && previewInfo.value && (
            <Form.Field>
              <TextArea value={previewInfo.value} />
            </Form.Field>
          )}
          {previewInfo && previewInfo.valueSummary && (
            <Form.Field>
              <label style={{ textTransform: 'none' }}>{previewInfo.valueSummary}</label>
            </Form.Field>
          )}
          <Button
            disabled={isLoading || !enablePreview}
            loading={previewInfo.isLoading}
            type="button"
            basic
            onClick={onAssetCriteriaPreviewButtonClicked}
          >
            Preview
          </Button>
        </Grid.Column>
        <Grid.Column width={8}>
          <Form.Field>
            <label>Location (s)</label>
            <Dropdown
              placeholder="Search Locations"
              multiple
              fluid
              search
              selection
              options={locationSearchInfo.items || []}
              value={locationIds || []}
              name="locationIds"
              onChange={(event, data) => {
                onAssetCriteriaChange(data, formik);
              }}
              onSearchChange={(event) => {
                onAssetCriteriaLocationSearchChange({ formik, event });
              }}
              loading={locationSearchInfo.isLoading}
              disabled={isLoading}
            />
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default AssetCriteriaComponent;
